import React, { Component } from 'react';

export interface IProps {}

export default class TransitionPage extends Component<IProps> {
    render() {
        return <b>Card not supported - Transition Page</b>;
    }
}
